import React from 'react';
import './Pages.css';

const Cookies: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Cookie Policy</h1>
      </div>
      
      <div className="page-content legal-content">
        <p className="last-updated">Last updated: January 2024</p>

        <section className="content-section">
          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit our website. 
            They help us provide a better user experience and understand how our service is used.
          </p>
        </section>

        <section className="content-section">
          <h2>How We Use Cookies</h2>
          <h3>Essential Cookies</h3>
          <p>Required for the website to function properly:</p>
          <ul>
            <li>Session management</li>
            <li>Security features</li>
            <li>User authentication</li>
          </ul>

          <h3>Analytics Cookies</h3>
          <p>Help us understand how visitors use our website:</p>
          <ul>
            <li>Page views and navigation patterns</li>
            <li>Time spent on pages</li>
            <li>Error tracking</li>
          </ul>

          <h3>Preference Cookies</h3>
          <p>Remember your choices and preferences:</p>
          <ul>
            <li>Language preferences</li>
            <li>Display settings</li>
            <li>Previous interactions</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>Third-Party Cookies</h2>
          <p>
            We may use third-party services that set their own cookies:
          </p>
          <ul>
            <li>Google Analytics (anonymized)</li>
            <li>Payment processors</li>
            <li>Social media widgets</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>Managing Cookies</h2>
          <p>
            You can control cookies through your browser settings:
          </p>
          <ul>
            <li>Block all cookies</li>
            <li>Delete existing cookies</li>
            <li>Allow cookies from specific sites only</li>
          </ul>
          <p>
            Note: Blocking essential cookies may affect website functionality.
          </p>
        </section>

        <section className="content-section">
          <h2>Updates to This Policy</h2>
          <p>
            We may update this Cookie Policy periodically. Check this page for the latest version.
          </p>
        </section>

        <section className="content-section">
          <h2>Contact Us</h2>
          <p>
            Questions about our use of cookies?<br/>
            Email: <a href="mailto:privacy@dreif-ai.com">privacy@dreif-ai.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Cookies;